import {gql} from "@irati/utils/gql"

export default gql`
  mutation RemoveUserFromTeam($teamId: ID!, $userId: ID!) {
    removeUserFromTeam(teamId: $teamId, userId: $userId)
  }
`
